import { createRouter } from "@tanstack/react-router";
import { rootRoute } from "./routes/root";
import { indexRoute } from "./routes/index";
import { signInRoute } from "./routes/sign-in";
import { staffRoute, staffIndexRoute } from "./routes/staff";
import { plotloungeRoomsListRoute } from "./routes/staff-plotlounge-rooms";
import { plotloungeRoomDetailRoute } from "./routes/staff-plotlounge-room-detail";
import { plotloungeRoomNewRoute } from "./routes/staff-plotlounge-room-new";
import { staffMargauxPromptRoute } from "./routes/staff-margaux-prompt";
import { staffFacilitatorsRoute } from "./routes/staff-facilitators";
import { staffDiscoverableClubsRoute } from "./routes/staff-discoverable-clubs";
import { facilitateRoute, facilitateIndexRoute } from "./routes/facilitate";
import { facilitateInviteRoute } from "./routes/facilitate-invite";
import { facilitateRoomDetailRoute } from "./routes/facilitate-room-detail";
import { clubsRoute, clubsIndexRoute, clubDetailRoute } from "./routes/clubs";
import { clubsVotingRoute } from "./routes/clubs-voting";
import { clubsGatheringsRoute } from "./routes/clubs-gatherings";
import { clubsGatheringsNewRoute } from "./routes/clubs-gatherings-new";
import { clubsGatheringsDetailRoute } from "./routes/clubs-gatherings-detail";
import { clubsRoomsNewRoute } from "./routes/clubs-rooms-new";
import { clubsRoomsDetailRoute } from "./routes/clubs-rooms-detail";
import { prototypesRoute } from "./routes/prototypes";
import { discoverRoute } from "./routes/discover";
import { gatheringDetailRoute } from "./routes/gathering-detail";
import { rsvpCancelRoute } from "./routes/rsvp-cancel";

const staffWithChildren = staffRoute.addChildren([
  staffIndexRoute,
  plotloungeRoomsListRoute,
  plotloungeRoomNewRoute,
  plotloungeRoomDetailRoute,
  staffMargauxPromptRoute,
  staffFacilitatorsRoute,
  staffDiscoverableClubsRoute,
]);

const facilitateWithChildren = facilitateRoute.addChildren([
  facilitateIndexRoute,
  facilitateInviteRoute,
  facilitateRoomDetailRoute,
]);

const clubsWithChildren = clubsRoute.addChildren([
  clubsIndexRoute,
  clubDetailRoute,
  clubsVotingRoute,
  clubsGatheringsRoute,
  clubsGatheringsNewRoute,
  clubsGatheringsDetailRoute,
  clubsRoomsNewRoute,
  clubsRoomsDetailRoute,
]);

const routeTree = rootRoute.addChildren([
  indexRoute,
  signInRoute,
  discoverRoute,
  gatheringDetailRoute,
  rsvpCancelRoute,
  staffWithChildren,
  clubsWithChildren,
  facilitateWithChildren,
  prototypesRoute,
]);

export const router = createRouter({ routeTree });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
